import type { TowerRoll } from '@/types'
import { ROLL_DIMENSIONS } from '@/types'
import { regularRolls, hotRolls } from '@/assets/rolls'

interface RollProps {
  roll: TowerRoll
}

export default function Roll({ roll }: RollProps) {
  const isHot = roll.type === 'hot'
  
  // Получаем правильный SVG для ролла
  const rollAsset = isHot 
    ? hotRolls[roll.variant >= 6 ? (roll.variant - 6) % hotRolls.length : 0]
    : regularRolls[(roll.variant - 1) % regularRolls.length]
  
  // Точные размеры из SVG viewBox — один в один как в файле
  const dims = ROLL_DIMENSIONS[roll.variant]
  
  return (
    <div 
      className="relative"
      style={{
        width: dims.width,
        height: dims.height,
      }}
    >
      {/* Программный эффект свечения для HOT роллов — оптимизировано (1 слой, без blur) */}
      {isHot && (
        <div 
          className="absolute rounded-full animate-fire-glow"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '140%',
            height: '140%',
            background: 'radial-gradient(circle, rgba(255,120,0,0.7) 0%, rgba(255,60,0,0.3) 45%, transparent 65%)',
          }}
        />
      )}
      
      {/* Свечение для бонусного ролла */}
      {roll.isBonus && (
        <div 
          className="absolute -inset-2 rounded-full animate-pulse"
          style={{
            background: 'radial-gradient(circle, rgba(255,215,0,0.6) 0%, transparent 70%)',
          }}
        />
      )}
      
      {/* Сам ролл */}
      <img 
        src={rollAsset.src}
        alt={rollAsset.name}
        className="w-full h-full object-contain"
        style={{
          filter: isHot 
            ? 'drop-shadow(0 0 6px rgba(255,100,0,0.5))' 
            : roll.isBonus 
              ? 'drop-shadow(0 0 4px rgba(255,215,0,0.4))'
              : 'none',
          transform: 'translateZ(0)',
          WebkitBackfaceVisibility: 'hidden',
        }}
        draggable={false}
      />
      
      {/* Индикатор бонусного ролла */}
      {roll.isBonus && (
        <div 
          className="absolute -top-1 -right-1 w-5 h-5 bg-yellow-400 rounded-full flex items-center justify-center text-[#282E44] text-[10px] font-black shadow-md"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          ×2
        </div>
      )}
    </div>
  )
}


